// Human-readable presentation of canonical backend enums (§21).
// Enums stay canonical server-side; these maps are display-only.

export const ORDER_STATUS = {
  CHECKOUT_HOLD: "Awaiting payment",
  PAYMENT_PROCESSING: "Payment processing",
  AWAITING_DEPOSIT: "Awaiting deposit",
  CONFIRMED: "Confirmed — deposit paid",
  BALANCE_DUE: "Balance due",
  PAID: "Paid",
  PARTIALLY_FULFILLED: "Partially shipped",
  FULFILLED: "Shipped",
  ADMIN_REVIEW: "Under review",
  CANCELLED: "Cancelled",
  EXPIRED: "Checkout expired",
  FAILED: "Payment failed",
  REFUNDED: "Refunded",
  REFUND_INITIATED: "Refund pending",
  REFUND_FAILED: "Refund failed",
};

export const LINE_STATUS = {
  PENDING_PAYMENT: "Awaiting payment",
  READY: "Preparing",
  PACKED: "Packed — awaiting carrier handoff",
  AWAITING_RECEIPT: "Waiting for incoming inventory",
  FULFILLED: "Shipped",
  RELEASED: "Released",
};

export const RESERVATION_STATUS = {
  ACTIVE: "Active",
  PENDING_APPROVAL: "Pending approval",
  CONVERTED: "Converted to order",
  EXPIRED: "Expired",
  CANCELLED: "Cancelled",
  DECLINED: "Declined",
};

export const SAMPLE_STATUS = {
  // V4.7 SAMPLE-167/168: coherent operational states with plain labels
  REQUESTED: "Preparing",
  QUOTE_SENT: "Quote sent — review needed",
  AWAITING_PAYMENT: "Awaiting payment",
  PAID_READY: "Paid — ready to fulfill",
  PARTIALLY_SENT: "Partially shipped",
  SENT: "Shipped",
  DELIVERED: "Delivered",
  CANCELLED: "Cancelled",
};

export const PROJECT_STAGE = {
  EXPLORING: "Exploring",
  SELECTED: "Selected",
  SAMPLED: "Sampled",
  QUOTING_CALCULATING: "Quoting",
  RESERVED: "Reserved",
  ORDERED: "Ordered",
  WON: "Won",
  COMPLETED: "Completed",
  ON_HOLD: "On hold",
  LOST_CLOSED: "Lost / closed",
};

export const PROJECT_LOST_REASONS = {
  PRICE: "Price",
  LEAD_TIME: "Lead time",
  DESIGN_MATERIAL: "Design / material",
  CANCELLED: "Cancelled",
  COMPETITOR: "Competitor",
  CLIENT_CHANGED_DIRECTION: "Client changed direction",
  NO_RESPONSE: "No response",
  OTHER: "Other",
};

export const CONTAINER_STATUS = {
  IN_MOROCCO: "In Morocco — preparing",
  DEPARTED: "In transit",
  ARRIVING: "Arriving Miami",
  RECEIVED: "Received",
};

export const ORDER_EVENT = {
  CHECKOUT_HOLD: "Order created — awaiting payment",
  AWAITING_DEPOSIT: "Order created — awaiting 30% deposit",
  CONFIRMED: "Deposit received — order confirmed",
  BALANCE_DUE: "Ready to ship — 70% balance due",
  PAID: "Payment received",
  PAYMENT_PROCESSING: "Payment processing (bank debit)",
  PARTIALLY_FULFILLED: "Partially shipped",
  FULFILLED: "Shipped",
  EXPIRED: "Checkout expired — inventory released",
  CANCELLED: "Cancelled",
  ADMIN_REVIEW: "Under review",
  REFUNDED: "Refund confirmed by payment provider",
  REFUND_INITIATED: "Refund started",
  REFUND_FAILED: "Refund failed",
  FAILED: "Payment failed",
};

export function human(map, value) {
  return map[value] || value || "—";
}

// §29.4: truthful natural-language units — correct plurals, never bare "+s"
const UNIT_PLURALS = {
  "loose tile": "loose tiles",
  "tile": "tiles",
  "mosaic sheet": "sheets",
  "sheet": "sheets",
  "box": "boxes",
  "pallet": "pallets",
};

export function pluralizeUnit(unit, qty) {
  const u = unit || "loose tile";
  return qty === 1 ? u : (UNIT_PLURALS[u] || `${u}s`);
}
